import { useAsync, type AsyncState } from "@/components/useAsync";
import {
  fetchLocationQuestionnaires,
  fetchPrivateResponse,
  fetchWorkingComment,
  type LocationQuestionnaire,
} from "@/data/interventionsRepository";
import type { QuestionnaireResponse } from "@/domain/questionnaire";

export interface EditorSources {
  locations: LocationQuestionnaire[];
  response: QuestionnaireResponse | null;
  /** Administrators' working comment; "" when there is none or it isn't loaded. */
  comment: string;
}

/**
 * Loads the location→questionnaire assignments and, when editing, the saved
 * response and (for administrators) the working comment.
 */
export function useEditorSources(
  interventionId: string | null,
  loadComment: boolean,
): AsyncState<EditorSources> {
  const [state] = useAsync(
    `editor:${interventionId ?? "new"}:${loadComment ? "comment" : ""}`,
    async () => {
      const [locations, response, comment] = await Promise.all([
        fetchLocationQuestionnaires(),
        interventionId ? fetchPrivateResponse(interventionId) : Promise.resolve(null),
        interventionId && loadComment ? fetchWorkingComment(interventionId) : Promise.resolve(""),
      ]);
      return { locations, response, comment };
    },
  );
  return state;
}
